import { FC } from 'react';

interface FlightTakeoffIconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const FlightTakeoffIcon: FC<FlightTakeoffIconProps> = ({ className, width, height, ...props }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      width={width}
      height={height}
      {...props}
    >
      <g clip-path='url(#clip0_1431_407)'>
        <path
          d='M2.49997 19.0001H21.5V21.0001H2.49997V19.0001ZM22.07 9.64007C21.86 8.84007 21.03 8.36007 20.23 8.58007L14.92 10.0001L8.01997 3.57007L6.08997 4.08007L10.23 11.2501L5.25997 12.5801L3.28997 11.0401L1.83997 11.4301L4.42997 15.9201C4.42997 15.9201 11.55 14.0201 21 11.4901C21.81 11.2601 22.28 10.4401 22.07 9.64007Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_1431_407'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
